import { Rating } from '@mui/material';

interface StarRatingProps {
    value: number | undefined;
    onChange: (rating: number) => void;
    size?: 'small' | 'medium';
    disabled?: boolean;
}

/** 0–5 stars; clicking a star sets it, clicking the same star again clears the rating to 0. */
export const StarRating = ({ value, onChange, size = 'small', disabled }: StarRatingProps) => (
    <Rating
        value={value ?? 0}
        max={5}
        size={size}
        disabled={disabled}
        onChange={(_event, next) => onChange(next ?? 0)}
        onClick={(event) => event.stopPropagation()}
    />
);
